import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Router } from '@angular/router';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { APP_PATHS } from '../../../../../core/config/app-paths';
import { ApplicationFormDetails } from '../../../../../shared/models/application-form-details';
import { getMonthName } from '../../../../../shared/constants/month-options';
import {
  APPLICATION_GROUP_LABELS,
  ApplicationGroup,
  getApplicationGroupDropdownItems,
} from '../../../../../shared/enums/application-group.enum';
import { PRZEDSIEBIORCY_FILTER_LABELS } from '../../../../../shared/enums/application-list-przedsiebiorcy.enum';
import { SWIADCZENIOBIORCY_FILTER_LABELS } from '../../../../../shared/enums/application-list-swiadczeniobiorcy.enum';
import { ValueOrDashPipe } from '../../../../../shared/pipes/value-or-dash.pipe';
import { BooleanLabelPipe } from '../../../../../shared/pipes/boolean-label.pipe';

@Component({
  selector: 'app-application-form-details',
  imports: [Button, Card, ValueOrDashPipe, BooleanLabelPipe],
  templateUrl: './application-form-details.component.html',
  styleUrl: './application-form-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationFormDetailsComponent {
  applicationForm = input.required<ApplicationFormDetails>();

  readonly #router = inject(Router);

  protected readonly getMonthName = getMonthName;
  protected readonly areaOptions = getApplicationGroupDropdownItems();

  readonly #visibleForAreaLabels = {
    ...SWIADCZENIOBIORCY_FILTER_LABELS,
    ...PRZEDSIEBIORCY_FILTER_LABELS,
  };

  protected visibleForAreasLabels = computed(
    () =>
      this.applicationForm()!
        .wyswietlajDlaObszarow?.map((v) => this.#visibleForAreaLabels[v])
        .filter(Boolean)
        .join(', ') || '',
  );

  protected areaLabel(value: ApplicationGroup | null): string {
    return value ? APPLICATION_GROUP_LABELS[value] : '-';
  }

  protected onBack(): void {
    this.#router.navigate([
      `/${APP_PATHS.admin.root}/${APP_PATHS.admin.applications}`,
    ]);
  }

  protected onEdit(): void {
    const applicationId = this.applicationForm().id;

    this.#router.navigate([
      `/${APP_PATHS.admin.root}/${APP_PATHS.admin.applications}/${applicationId}/${APP_PATHS.admin.edit}`,
    ]);
  }
}
